<div *ngIf="movie.description" class="movie-detail-section">
  <div class="header-msg title" i18n="@@movie.menu.synopsis">Synopsis</div>
  <div class="text"
    [innerHTML]="movie.friendlyUrl + '.synopsis' | translate: { placeholder: movie.description } | safe: 'html'">
  </div>
</div>

<div class="movie-pic">
  <img [ngSrc]="movie.portraitPhotoUrl || portraitPlaceholder" [alt]="movie.trTitle + ' poster image'" width="300"
    height="400" style="height: auto"
    [modal]="{ src: movie.portraitPhotoUrl, type: 'portrait', movie: movie, imgType: 'poster-img' }" addSkeleton />
</div>

